var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowGreenIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#41AAAF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rightArrowGreenIcon_svg__clip0_2248_5479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.154 6.98s.054.042.074.06c1.36 1.327 4.156 4.064 4.156 4.08-.037.03-2.261 2.184-3.337 3.232l-.903.878c-.283-.282-.56-.563-.836-.844v-.026c.02-.015 2.224-2.156 3.306-3.21.018-.018.033-.039.05-.06l-.058-.062-3.228-3.145a.5.5 0 01-.07-.08l.846-.823z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rightArrowGreenIcon_svg__clip0_2248_5479"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 12.27 2.961)",
    d: "M0 0h8.25v5.077H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowGreenIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/rightArrowGreenIcon.92131a19.svg";
export { MemoForwardRef as ReactComponent };